/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    blockquote: "blockquote",
    a: "a",
    pre: "pre",
    h4: "h4",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "css"
      }), " prop | v4"]
    }), "\n", _jsxs(_components.p, {
      children: ["Sometimes you don't want to create an extra component just to apply a bit of styling. The ", _jsx(_components.code, {
        children: "css"
      }), " prop is a convenient way to iterate on your components without settling on fixed component boundaries yet. It works on both normal HTML tags as well as components, and supports everything any styled component supports, including adapting based on props, theming and custom components."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["To enable support for the ", _jsx(_components.code, {
          children: "css"
        }), " prop you have to use the ", _jsx(_components.a, {
          href: "/docs/tooling#babel-plugin",
          children: "Babel plugin"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "<div\n  css={`\n    background: papayawhip;\n    color: ${props => props.theme.colors.text};\n  `}\n/>\n<Button\n  css=\"padding: 0.5em 1em;\"\n/>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Under the hood, the Babel plugin turns any element with a ", _jsx(_components.code, {
        children: "css"
      }), " prop into a styled component. For example, the above code becomes:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-javascript",
        children: "import styled from 'styled-components';\n\nconst StyledDiv = styled.div`\n  background: papayawhip;\n  color: ${props => props.theme.colors.text};\n`\n\nconst StyledButton = styled(Button)`\n  padding: 0.5em 1em;\n`\n\n<StyledDiv />\n<StyledButton />\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "Note that you don't even have to add the import, the Babel plugin does that automatically! (unless you're using the Babel macro, see below)"
    }), "\n", _jsx(_components.h4, {
      children: "Usage with the Babel macro"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["This functionality was removed in v6.1 due to lack of usage and unnecessary bloat for other consumers. ", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components/issues/4064",
          children: "More info"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["You can use the ", _jsx(_components.a, {
        href: "/docs/tooling#babel-macro",
        children: "Babel macro"
      }), " to make this work in ", _jsx(_components.code, {
        children: "create-react-app"
      }), ". Unfortunately, Babel macros only run when imported so ", _jsx(_components.strong, {
        children: "the import can not be added automatically."
      }), " The above code works perfectly if you add the import to the macro manually:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import styled from 'styled-components/macro'\n\n<div\n  css={`\n    background: papayawhip;\n    color: ${props => props.theme.colors.text};\n  `}\n/>\n<Button\n  css=\"padding: 0.5em 1em;\"\n/>\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "Usage with TypeScript"
    }), "\n", _jsxs(_components.p, {
      children: ["To prevent TypeScript errors on the ", _jsx(_components.code, {
        children: "css"
      }), " prop on arbitrary elements, install ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), " and add the following import once in your project:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "import {} from 'styled-components/cssprop'\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["See ", _jsx(_components.a, {
        href: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384",
        children: "https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-446011384"
      }), " for more information."]
    }), "\n", _jsxs(_components.p, {
      children: ["If you're using a higher version than v6, you do not need to install ", _jsx(_components.code, {
        children: "@types/styled-components"
      }), ".\nInstead, you can directly import the ", _jsx(_components.code, {
        children: "CSSProp"
      }), " in your project like this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "import {} from 'react'\nimport type { CSSProp } from 'styled-components'\n\ndeclare module 'react' {\n  interface Attributes {\n    css?: CSSProp | undefined\n  }\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
